import { Grid } from '@mui/material'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { SectorComercialFields } from 'src/types'
import { AsyncSelect, ControlledDatePicker, ControlledTextField } from "src/components/forms"
import { useLoadOptions } from "src/hooks/useLoadOptions"
import { useCFOperacionTipos, useCFSectorComercialTipos, useCFUnidadNegocio } from "../hooks/useCFCache"
import { OperacionCFFields } from '../types/fields'
import { SectionBox } from 'src/pages/sistema/components/FieldView'
import CardActions from 'src/pages/sistema/components/CardActions'
import { OperacionCFTipo } from '../types/enum'
import { useEffect } from 'react'

interface SeccionCFDatosOperacionProps {
  formMethods: UseFormReturn<any>
  codSistema: number,
  codPais: number
}

export const SeccionNuevoCFDatosOperacion = ({ formMethods, codSistema, codPais }: SeccionCFDatosOperacionProps) => {
  const { control, setValue, trigger } = formMethods

  const unidadNegocioHook = useCFUnidadNegocio(codPais, codSistema)
  const loadUnidadNegocio = useLoadOptions({
    data: unidadNegocioHook.unidadNegocio,
    loading: unidadNegocioHook.isLoading,
    isError: unidadNegocioHook.isError,
    error: unidadNegocioHook.error
  });

  const tipoClienteHook = useCFOperacionTipos(codSistema)
  const loadClienteTipos = useLoadOptions({
    data: tipoClienteHook.operacionTipos,
    loading: tipoClienteHook.isLoading,
    isError: tipoClienteHook.isError,
    error: tipoClienteHook.error
  });

  const watchedUnidadNegocio = useWatch({ control: control, name: OperacionCFFields.CodUnidadNegocio });
  const watchedSectorComercial = useWatch({ control: control, name: OperacionCFFields.CodSectorComercial });
  const watchedTipoCliente = useWatch({ control, name: OperacionCFFields.CodOperacionCFTipo })

  const sectorComercialTipos = useCFSectorComercialTipos(watchedUnidadNegocio, codSistema);
  const loadSectorComercial = useLoadOptions({
    data: sectorComercialTipos.sectorComercialTipos,
    loading: sectorComercialTipos.isLoading,
    isError: sectorComercialTipos.isError,
    error: sectorComercialTipos.error
  });



  // Lógica condicional: Si cambia a Prospecto, limpiamos el Nro de Cuenta
  useEffect(() => {
    if (watchedTipoCliente === OperacionCFTipo.Prospecto) { // 1 = Prospecto
      setValue(OperacionCFFields.NumeroCuenta, '')
    }
    if (watchedTipoCliente === OperacionCFTipo.Cliente) { // 2 = Cliente
      trigger(OperacionCFFields.NumeroCuenta)
    }
  }, [watchedTipoCliente, setValue, trigger])

  useEffect(() => {
    setValue(OperacionCFFields.CodSectorComercial, null, {
      shouldDirty: true,
      shouldValidate: true
    })
  }, [watchedUnidadNegocio, setValue])

  useEffect(() => {
    if (unidadNegocioHook.unidadNegocio.length === 1 && !watchedUnidadNegocio) {
      setValue(
        OperacionCFFields.CodUnidadNegocio,
        unidadNegocioHook.unidadNegocio[0][SectorComercialFields.UnidadNegocioCodigo],
        { shouldDirty: true, shouldValidate: true }
      )
    }
  }, [setValue, unidadNegocioHook.unidadNegocio, watchedUnidadNegocio])

  useEffect(() => {
    if (sectorComercialTipos.sectorComercialTipos.length === 1 && !watchedSectorComercial) {
      setValue(
        OperacionCFFields.CodSectorComercial,
        sectorComercialTipos.sectorComercialTipos[0][SectorComercialFields.SectorComercialCodigo],
        { shouldDirty: true, shouldValidate: true }
      )
    }
  }, [setValue, sectorComercialTipos.sectorComercialTipos, watchedSectorComercial])

  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      <SectionBox>
        <Grid item container xs={12} spacing={3}>
          <Grid item xs={12} md={4}>
            <AsyncSelect
              label={'Unidad de Negocio'}
              name={OperacionCFFields.CodUnidadNegocio}
              valueField={SectorComercialFields.UnidadNegocioCodigo}
              loadOptions={loadUnidadNegocio}
              control={control}
              selectNotNulleable
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <AsyncSelect
              label={'Equipo Comercial'}
              name={OperacionCFFields.CodSectorComercial}
              valueField={SectorComercialFields.SectorComercialCodigo}
              loadOptions={loadSectorComercial}
              control={control}
              selectNotNulleable
              fullWidth
            />
          </Grid>
        </Grid>
        {/* <Grid item xs={12} md={4}>
          <ControlledDatePicker name={OperacionCFFields.FechaSolicitud} control={control} label='Fecha Solicitud' />
        </Grid> */}

        <Grid item xs={12} md={4}>
          <ControlledTextField
            label='Razón social'
            name={OperacionCFFields.RazonSocial}
            control={control}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <AsyncSelect
            label='Prospecto o cliente'
            name={OperacionCFFields.CodOperacionCFTipo}
            loadOptions={loadClienteTipos}
            control={control}
            fullWidth
            selectNotNulleable
          />
        </Grid>

        {watchedTipoCliente === OperacionCFTipo.Cliente && (
          <Grid item xs={12} md={3}>
            <ControlledTextField
              label='Número de cuenta'
              name={OperacionCFFields.NumeroCuenta}
              control={control}
              fullWidth
            />
          </Grid>
        )}

      </SectionBox>
    </CardActions>
  )
}
